<template>
    <div class="text-center text-lg text-gray-500 max-w-3xl mx-auto">
        <slot />
    </div>
</template>
